import { defineMessages } from 'react-intl';

const messages = defineMessages({
  viewOrder: {
    id: 'add-ons.orders.view-order',
    defaultMessage: 'View Order'
  },
  messageBuyer: {
    id: 'add-ons.orders.message-buyer',
    defaultMessage: 'Message Buyer'
  },
  refundCancel: {
    id: 'add-ons.orders.refund-cancel',
    defaultMessage: 'Refund & Cancel'
  },
  checkedIn: {
    id: 'add-ons.orders.checked-in',
    defaultMessage: 'Redeemed'
  },
  checkedOut: {
    id: 'add-ons.orders.checked-out',
    defaultMessage: 'Not redeemed'
  },
  refundTitle: {
    id: 'add-ons.orders.refund-title',
    defaultMessage: 'Refund and cancel add-ons'
  },
  refundUndo: {
    id: 'add-ons.orders.refund-undo',
    defaultMessage: 'This action cannot be undone'
  },
  refundOrder: {
    id: 'add-ons.orders.refund-order',
    defaultMessage: 'Refund Order'
  },
  cancelled: {
    id: 'add-ons.orders.cancelled',
    defaultMessage: 'Cancelled'
  },
  markAsNotRedeemed: {
    id: 'add-ons.orders.mark-not-redeemed',
    defaultMessage: 'Mark as Not Redeemed'
  },
  markAsRedeemed: {
    id: 'add-ons.orders.mark-redeemed',
    defaultMessage: 'Mark as Redeemed'
  },
  Buyer: {
    id: 'add-ons.orders.buyer',
    defaultMessage: 'Buyer'
  },
});

export default messages;
